import React from 'react';
import { Link } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-bold text-gray-900">{title}</h2>
      <div className="text-sm text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 py-12" data-testid="terms-page">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border p-8 space-y-6">
        <div>
          <Link to="/" className="text-sm text-purple-600 hover:underline">← Back to home</Link>
          <h1 className="mt-2 text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-xs text-gray-400 mt-1">Last updated: February 2026</p>
        </div>

        <Section title="1. Acceptance of Terms">
          By creating an account on Tranchly or using any of our services, you agree to be bound by these Terms of Service.
          If you do not agree with these terms, do not use the platform.
        </Section>

        <Section title="2. Platform Description">
          Tranchly is a private credit marketplace that connects small-business borrowers with retail and accredited investors.
          Tranchly is <strong>not</strong> a bank, broker-dealer, or registered investment adviser. We facilitate loan
          origination and servicing but do not provide investment advice.
        </Section>

        <Section title="3. Investment Risk Disclosure">
          Investments made through Tranchly involve significant risk, including possible loss of all principal.
          Returns are not guaranteed. Past performance does not predict future results. Tranchly investments are not
          FDIC insured, not bank deposits, and are not backed by any government agency.
        </Section>

        <Section title="4. Borrower Obligations">
          Borrowers represent that all information provided during application is true and accurate. Borrowers agree to
          repay loans on schedule and acknowledge that late payments may incur fees and damage their Capital Passport.
        </Section>

        <Section title="5. Investor Obligations">
          Investors represent that they meet any applicable accreditation or suitability requirements and understand the
          risks described above. Investors complete a one-time suitability questionnaire prior to accessing the marketplace.
        </Section>

        <Section title="6. Prohibited Uses">
          You may not use Tranchly to launder money, finance illegal activity, evade taxes, or violate any applicable law.
          We reserve the right to suspend or terminate any account at our discretion.
        </Section>

        <Section title="7. Intellectual Property">
          All platform content, branding, and software are the property of Tranchly. You may not copy, distribute, or
          reverse-engineer any part of the platform without written permission.
        </Section>

        <Section title="8. Limitation of Liability">
          To the maximum extent permitted by law, Tranchly is not liable for any indirect, incidental, or consequential
          damages arising from your use of the platform, including but not limited to loss of principal on investments.
        </Section>

        <Section title="9. Governing Law">
          These Terms are governed by the laws of the State of Delaware, United States of America. Any disputes shall
          be resolved exclusively in courts located in Delaware.
        </Section>

        <Section title="10. Contact">
          Questions about these Terms? Email us at <a className="text-purple-600 hover:underline" href="mailto:hello@tranchly.finance">hello@tranchly.finance</a>.
        </Section>

        <p className="text-xs text-gray-400 border-t pt-4">
          Not FDIC insured. Not investment advice. Principal at risk. Tranchly is not a licensed bank.
        </p>
      </div>
    </div>
  );
}
